// NOTE: hooks
import { useState } from "react"
import { IoClose } from 'react-icons/io5'
// NOTE: components
import Card from "../ui/Card"
import Modal from "../ui/Modal"
import ReactPlayer from "react-player"

interface VideosCardProps {
	url: string
	className: string
	skeletonClassName: string
}


const VideosCard = ({ url, className, skeletonClassName }: VideosCardProps) => {
	const [show, setShow] = useState(false)

	const skeleton = <div className={`skeleton ${skeletonClassName}`} />

	return (
		<>
			{/* NOTE: use display flex at the top level to prevent safari from breaking image and card when using columns css  */}
			<div className="flex">
				<Modal show={show} onHide={() => setShow(false)} size="lg" className="!overflow-visible">
					<button
						className="absolute -top-5 -right-4 p-1 rounded-full bg-white text-dark cursor-pointer z-50"
						onClick={() => setShow(false)}
					>
						<IoClose className="text-3xl text-slate-900" />
					</button>

					<div className="p-0.5 h-[70vh] max-h-[500px] min-h-[300px]">
						<ReactPlayer
							width="100%"
							height="100%"
							url={url}
							playing={true}
							controls={true}
							config={{
								youtube: {
									playerVars: {
										modestbranding: 1,
										rel: 0,
										showinfo: 0,
										disablekb: 1,
									}
								},
								file: {
									attributes: {
										controlsList: 'nodownload',
										disablePictureInPicture: true
									}
								}
							}}
						/>
					</div>
				</Modal>

				<Card className={`w-full !overflow-hidden ${className}`} onClick={() => setShow(true)}>
					<ReactPlayer
						width="100%"
						height="100%"
						light={true}
						url={url}
						playing={false}
						controls={false}
						fallback={skeleton}
						className="pointer-events-none"
						config={{
							file: {
								attributes: {
									controlsList: 'nodownload',
								}
							}
						}}
					/>
				</Card>
			</div>
		</>
	)
}

export default VideosCard